import React, { useContext, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Media,
  Tooltip,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import UserContext from "./UserContext";
import SettingsModal from "./SettingModal";

/**
 * TableHeader — shared header for all table pages
 *
 * Props:
 * - title         (string)   — table name, always shown
 * - onRefresh     (fn)       — refresh button, always shown
 * - onBack        (fn)       — optional back arrow
 * - onDownload    (fn)       — optional download icon
 * - totalCount    (number)   — optional total entries badge
 * - hasMore       (bool)     — if true, shows "+" after totalCount
 * - filterContent (node)     — optional filter row rendered below the header bar
 */
const TableHeader = ({
  title,
  onRefresh,
  onBack,
  onDownload,
  totalCount,
  hasMore,
  filterContent,
}) => {
  const userContext = useContext(UserContext);
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const [error, setError] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
    setError("");
  };

  const doLogout = () => {
    userContext.doLogin("logged-out");
    history.push("/admin");
  };

  return (
    <div style={{ background: "#fff", borderBottom: "1px solid #e9ecef", flexShrink: 0, paddingRight: "16px" }}>
      

      <style>{`
    @media (max-width: 767.98px) {
      .admin-label { display: none; }
      .header-title { font-size: 15px !important; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 160px; }
      .total-badge { font-size: 11px !important; padding: 2px 7px !important; white-space: nowrap; }
    }
  `}</style>
      
      {/* Main header row */}
      <div style={{
        padding: "14px 0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
        {/* Left side: back arrow + title + count */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {onBack && (
            <i
              className="fas fa-arrow-left"
              style={{ cursor: "pointer", fontSize: 16, color: "#525f7f" }}
              onClick={onBack}
            />
          )}
          <h3 className="header-title" style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#32325d" }}>
            {title}
          </h3>
          {totalCount !== undefined && totalCount > 0 && (
            <span className="total-badge"  style={{
              fontSize: 13, color: "#6c757d", fontWeight: 400,
              background: "#f2f0f0", padding: "3px 10px", borderRadius: 12,
            }}>
              Total Events: {totalCount}{hasMore ? "+" : ""}
            </span>
          )}
        </div>

        {/* Right side: download + refresh + admin */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {onDownload && (
            <>
              <i
                id="downloadbtn"
                className="fa fa-download"
                style={{ cursor: "pointer", color: "#525f7f", fontSize: 18 }}
                onClick={onDownload}
              />
              <Tooltip
                isOpen={tooltipOpen}
                placement="top"
                target="downloadbtn"
                toggle={() => setTooltipOpen(!tooltipOpen)}
              >
                Download CSV
              </Tooltip>
            </>
          )}

          <i
            id="refreshbtn"
            className="fas fa-sync"
            style={{ cursor: "pointer", color: "#525f7f", fontSize: 18 }}
            onClick={onRefresh}
          />

          {/* Admin dropdown */}
          <UncontrolledDropdown className="d-none d-md-block">
            <DropdownToggle
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer", boxShadow: "none" }}
            >
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="admin"
                    src={require("../assets/img/theme/img_avatar.jpg").default}
                  />
                </span>
                <span className="ml-2 text-sm font-weight-bold  admin-label" style={{ color: "#32325d" }}>
                  Admin
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu right style={{ zIndex: 9999 }}>
              <DropdownItem onClick={doLogout}>
                <i className="fas fa-sign-out-alt" style={{ color: "red", marginRight: 8 }} />
                <span>Logout</span>
              </DropdownItem>
              <DropdownItem onClick={toggleModal}>
                <i className="fas fa-cog" style={{ color: "blue", marginRight: 8 }} />
                <span>Settings</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>

          <SettingsModal isOpen={modal} toggle={toggleModal} error={error} setError={setError} />
        </div>
      </div>

      {/* Optional filter row */}
      {filterContent && (
        <div style={{ padding: "0 24px 14px 0px" }}>
          {filterContent}
        </div>
      )}
    </div>
  );
};

export default TableHeader;